export default {"src":"/_next/static/media/printV2.5aaf04c0.svg","height":22,"width":28,"blurWidth":0,"blurHeight":0};